import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { Twitter, Linkedin, Mail } from 'lucide-react';
import TiktokIcon from '../components/tiktokIcon';
import { LayoutContext } from '../types/translations';

const Contact: React.FC = () => {
  const { texts } = useOutletContext<LayoutContext>();

  const contactMethods = [
    {
      name: 'TikTok',
      icon: <TiktokIcon className="w-6 h-6" />,
      link: 'https://www.tiktok.com/@your-username',
      color: 'text-pink-500',
      ariaLabel: 'TikTok',
    },
    {
      name: 'Twitter',
      icon: <Twitter className="w-6 h-6" />,
      link: 'https://twitter.com/your-username',
      color: 'text-blue-400',
      ariaLabel: 'Twitter',
    },
    {
      name: 'LinkedIn',
      icon: <Linkedin className="w-6 h-6" />,
      link: 'https://www.linkedin.com/in/anton-joncour-colombel-4a93a7302/',
      color: 'text-blue-600',
      ariaLabel: 'LinkedIn',
    },
    {
      name: 'Email',
      icon: <Mail className="w-6 h-6" />,
      link: 'mailto:your.email@domain.com',
      color: 'text-red-600',
      ariaLabel: 'Email',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#1a1a1a] text-gray-900 dark:text-white transition-colors duration-200">
      <main className="container mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold mb-12">{texts.contact.contact}</h1>
        <div className="flex flex-col items-center space-y-8">
          {contactMethods.map((method) => (
            <a
              key={method.name}
              href={method.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center space-x-4 p-4 border border-gray-300 dark:border-gray-700 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors`}
              aria-label={method.ariaLabel}
            >
              <span className={`${method.color}`}>{method.icon}</span>
              <span className="text-lg font-medium">{method.name}</span>
            </a>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Contact;
